import * as React from 'react';
import Layout from '../../components/Utilities/Layout';
import { Alert, AlertTitle, Box, Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Stack, Typography } from '@mui/material';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import EntityPermissions from '../../components/EntityPermissions';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ReactInterval from 'react-interval';
import Common from '../../utilities/common';
import $ from "jquery";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import { GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext, GridCsvExportOptions, GridToolbarContainer, DataGrid } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import IpsDataComunidadesChart from './IpsDataComunidadesChart';
import IpsDataComunidadesSexChart from './IpsDataComunidadesSexChart';
import IpsDataProvinciasSexChart from './IpsDataProvinciasSexChart';
import IpsDataMunicipiosSexChart from './IpsDataMunicipiosSexChart';

export interface IIpsDataState {
    progressData: any;
    logData: any[];
    openDialog: boolean;
}

export default class IpsData extends React.Component<{}, IIpsDataState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            progressData: null,
            logData: [],
            openDialog: false
        }
    }

    componentDidMount(): void {
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: '/settings'
                        },
                        {
                            title: 'IPs',
                            url: '/settings/ips'
                        },
                        {
                            title: 'Asignación de IPs a registros de la base de datos',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <LanguageOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Asignación de IPs a registros de la base de datos
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.IPS} permission={PermissionLevel.SuperAdministrar}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntityPermissions entity={Entity.IPS}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <IpsDataComunidadesChart />
                            </Grid>
                            <Grid item xs={8}>
                                <IpsDataComunidadesSexChart />
                            </Grid>
                            <Grid item xs={12}>
                                <IpsDataProvinciasSexChart />
                            </Grid>
                        </Grid>
                    </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }
}